import React from 'react';
import styled from 'styled-components';
const Icon = styled.svg``;
export default (() => /*#__PURE__*/React.createElement(Icon, {
  width: "16px",
  height: "28px",
  viewBox: "0 0 16 11",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "path-arrow-down",
  points: "10.5 -3 13.5 -3 13.5 7.5 3 7.5 3 4.5 10.5 4.5"
})), /*#__PURE__*/React.createElement("g", {
  id: "4-Icons",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-arrow-down"
})), /*#__PURE__*/React.createElement("use", {
  id: "Mask",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  transform: "translate(8.250000, 2.250000) scale(-1, 1) rotate(-315.000000) translate(-8.250000, -2.250000) ",
  xlinkHref: "#path-arrow-down"
}))));